function setupListener() {
  const countrySelector = document.querySelector('#footer-country-selector');
  const countryPopoverClose = document.querySelector('#footer-country-popover-close');
  const countryPopover = document.querySelector('#footer-country-popover');
  const countryItem = document.querySelectorAll('#footer-country-list a.country-item');
  const countryForm = document.querySelector('#country-form');
  const countryInput = document.querySelector('#country-form input[name="country_code"]');

  countrySelector.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    countryPopover.hidden = !countryPopover.hidden;
  });

  countryPopoverClose.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    countryPopover.hidden = true;
  });

  for (const item of countryItem) {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      countryPopover.hidden = true;

      let target = event.target;
      while (target.tagName !== 'A') {
        target = target.parentNode;
      }

      const countryCode = target.dataset.value;

      countryInput.value = countryCode;
      countryForm.submit();
    });
  }

  document.addEventListener('click', (event) => {
    if (!countryPopover.hidden && !countryPopover.contains(event.target)) {
      countryPopover.hidden = true;
    }
  });
}

setupListener();
